// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import resourcesReducer from './dataSlice'

export const store = configureStore({
  reducer: {
    resources: resourcesReducer,
  },
});